import axiosServices, { buildQueryParams, PaginationAndFiltersParams } from 'utils/axios';
import { GenericTableConfigDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';
import ListWithTotal from 'common/dto-types/list-with-total-dto';

export const getConfigs = async (params: PaginationAndFiltersParams): Promise<ListWithTotal<GenericTableConfigDto>> => {
    const res = await axiosServices.get<ListWithTotal<GenericTableConfigDto>>(
        `${InsideFifaBackOfficeEndpoints.GenericTables.Configs}${buildQueryParams(params)}`,
    );

    return res.data;
};
